
import { Record, Union } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { record_type, union_type, class_type, list_type, string_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { FormState_$reflection, TokenDataDto_$reflection, RequestedValue$1_$reflection, AccountSettings_$reflection, ClientApiResponse$1_$reflection } from "../../Shared/Shared.js";
import { DispolistElement_$reflection, Dispolist_$reflection } from "../../Shared/Dispolist.js";

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["DeleteDispolist", "DispolistDeleted", "DispolistFetched", "ToolsFetched", "AccountSettingsFetched", "FetchError"];
    }
}

export function Msg_$reflection() {
    return union_type("InventoryLists.Detail.Types.Msg", [], Msg, () => [[], [["Item", ClientApiResponse$1_$reflection(string_type)]], [["Item", Dispolist_$reflection()]], [["Item", list_type(DispolistElement_$reflection())]], [["Item", AccountSettings_$reflection()]], [["Item", class_type("System.Exception")]]]);
}

export class State extends Record {
    constructor(Dispolist, UserData, Elements, AccountSettings, FormState) {
        super();
        this.Dispolist = Dispolist;
        this.UserData = UserData;
        this.Elements = Elements;
        this.AccountSettings = AccountSettings;
        this.FormState = FormState;
    }
}

export function State_$reflection() {
    return record_type("InventoryLists.Detail.Types.State", [], State, () => [["Dispolist", RequestedValue$1_$reflection(Dispolist_$reflection())], ["UserData", TokenDataDto_$reflection()], ["Elements", RequestedValue$1_$reflection(list_type(DispolistElement_$reflection()))], ["AccountSettings", RequestedValue$1_$reflection(AccountSettings_$reflection())], ["FormState", FormState_$reflection()]]);
}

